import { Fragment } from 'react';
import { TotalBarProps } from '@mews-distributor/ui';
import { Divider, Stack } from '@optimus-web/core';

import { getIsFxMulticurrencyServiceEnabled } from '../../../../modules/app/selectors';
import { useAppSelector } from '../../../../utils/redux';
import { TotalBar } from '../../TotalBar/TotalBar';
import { TotalBarWithDccContainer } from '../../TotalBarWithDccContainer/TotalBarWithDccContainer';
import { getViewResourceOrders } from '../selectors';
import { PromotedServicesResourceOrder } from '../types';
import { withLoader } from '../withLoader';
import { ReservationGroupBreakdown } from './ReservationGroupBreakdown';
import { shouldDisplayTaxBreakDown } from './selectors';
import { TaxBreakDown } from './TaxBreakDown';

const renderPromotedServices = (promotedServices: PromotedServicesResourceOrder[]) =>
    promotedServices.map(({ count, name, rateName, reservationId, unitPrice, totalPrice, hourCount }) => (
        <ReservationGroupBreakdown
            reservationId={reservationId}
            key={reservationId}
            hourCount={hourCount}
            count={count}
            resourceName={name}
            rateName={rateName}
            unitPrice={unitPrice}
            totalPrice={totalPrice}
        />
    ));

const BaseTotalBarWithTaxBreakdown = ({ ...otherTotalBarProps }: TotalBarProps) => {
    const isFxMulticurrencyServiceEnabled = useAppSelector((state) => getIsFxMulticurrencyServiceEnabled(state));
    const resourceOrders = useAppSelector((state) =>
        getViewResourceOrders(state, { shouldSelectedCurrencyBeUsed: isFxMulticurrencyServiceEnabled })
    );
    const showTaxBreakDown = useAppSelector((state) =>
        shouldDisplayTaxBreakDown(state, { shouldSelectedCurrencyBeUsed: isFxMulticurrencyServiceEnabled })
    );

    return (
        <Stack spacing="100" vertical>
            <Stack spacing="100" vertical>
                {resourceOrders.map(({ reservation, room, unitPrice, totalPrice, rate }) => (
                    <Fragment key={reservation.orderId}>
                        <ReservationGroupBreakdown
                            reservationId={reservation.orderId}
                            key={reservation.orderId}
                            count={reservation.count}
                            resourceName={room.name}
                            rateName={rate.name}
                            unitPrice={unitPrice}
                            totalPrice={totalPrice}
                            showProductsBreakdown
                        />
                        {renderPromotedServices(reservation.promotedServices)}
                    </Fragment>
                ))}
            </Stack>

            <Divider />

            {showTaxBreakDown ? (
                <>
                    <TaxBreakDown />

                    <Divider />
                </>
            ) : null}

            {isFxMulticurrencyServiceEnabled ? (
                <TotalBarWithDccContainer {...otherTotalBarProps} />
            ) : (
                <TotalBar {...otherTotalBarProps} />
            )}
        </Stack>
    );
};

export const TotalBarWithTaxBreakdown = withLoader(BaseTotalBarWithTaxBreakdown);
